import RecurringProphyStudy from './studyConfig/RecurringProphyStudy'

export default new RecurringProphyStudy({
  molecule: 'Topiramate',
  smallText: 'e.g. Topamax, Trokendi XR',
  dosageOptions: [
    '25mg per day',
    '50mg per day',
    '100mg per day'
  ]
})



// WEBPACK FOOTER //
// ./src/store/recurring/recurringProphyTopiramate.js